module.exports = __webpack_public_path__ + "app/images/wxm.a384f21b.svg";